// tpmt is two power minus ten times t scaled to [0,1]
export function tpmt(x) {
  return (Math.pow(2, -10 * x) - 0.0009765625) * 1.0009775171065494;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_d3-ease@1.0.7@d3-ease/src/math.js
// module id = 89
// module chunks = 0